<template>
  <div v-cloak id="driver_info" class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>司機資料</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <router-link
          class="mybtnstyle btn-dark white_textcolor"
          :to="{ name: 'addDriver' }"
          v-if="permissionAddDriver"
        >
          新增司機
        </router-link>
        <button
          class="btn btn-primary"
          @click="openServiceModal"
          v-if="permissionDriverService"
        >
          設定預設服務內容
        </button>
        <button class="btn btn-primary" @click="openDriverLicenseModal">
          當月司機須審查名單
        </button>
        <button class="btn btn-success" @click="downloadDriver">
          下載司機資料
        </button>
        <h4 class="col-md-4">
          <i class="fa fa-user" />
          司機總數:
          <span class="red_textcolor">{{ list.length }}</span>
        </h4>
      </div>
    </div>
    <div>
      <el-tabs v-model="activeTab" @tab-click="onTab">
        <!--入隊司機tab-->
        <el-tab-pane label="入隊司機" name="general">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="搜尋關鍵字">
              <el-input
                class="driver-list-search"
                v-model="kw"
                placeholder="隊編、司機姓名、分隊、司機電話、車牌"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">搜尋</el-button>
            </el-form-item>
            <el-form-item label="篩選服務">
              <el-select
                v-model="serviceItem"
                multiple
                placeholder="篩選服務"
                @change="onChangeServiceItem"
              >
                <el-option
                  v-for="item in vx_serviceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="權限選擇">
              <el-select
                v-model="auth"
                placeholder="請選擇"
                @change="onChangeAuth"
                clearable
              >
                <el-option
                  v-for="item in AUTH_OPTIONS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <el-row>
            <el-col :span="1">
              <el-select v-model="paging.npp" @change="onSelect">
                <el-option
                  v-for="npp in [10, 25, 50, 100]"
                  :key="'generalNpp-' + npp"
                  :label="npp"
                  :value="npp"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <!--入隊司機table-->
          <InTeamTable
            :filter_list="filter_list"
            :permissionEditDriver="permissionEditDriver"
            @onTitle="onTitle"
            @changeDriverAuth="changeDriverAuth"
          />
        </el-tab-pane>
        <!--已封存司機tab-->
        <el-tab-pane label="已封存司機" name="seal">
          <el-row>
            <el-col :span="1">
              <el-select v-model="paging.npp" @change="onSelect">
                <el-option
                  v-for="npp in [10, 25, 50, 100]"
                  :key="'sealNpp-' + npp"
                  :label="npp"
                  :value="npp"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <!--已封存司機table-->
          <SealTable :filter_list="filter_list" @onTitle="onTitle" />
        </el-tab-pane>
      </el-tabs>
      <!--頁籤-->
      <el-row>
        <el-col :offset="10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="onPageChange"
            :page-count="paging.totalPages"
          />
        </el-col>
      </el-row>
    </div>
    <div>
      <!--unuse ModalForm component-->
      <!-- <ModalForm ref="modalForm" /> -->
      <!--BUG: 暫時使用舊版的元件，但更新服務是有問題的，修正過的元件為ServiceListModal-->
      <ServiceListModalBug
        ref="serviceListModal"
        :permissionEditDriverService="permissionEditDriverService"
      />
      <DriverLicenseModal ref="driverLicenseModal" />
      <el-dialog
        :title="dialogTitle"
        :visible="suspendDialog.visible"
        :before-close="beforeCloseSuspendDialog"
        width="70%"
      >
        <el-row>
          <el-col :span="24">
            <div>
              <h4 class="col-md-1">起始時間：</h4>
              <DateSelect
                :isDisabled="suspendDialog.eternalCheck"
                :isSuspension="true"
                ref="startTime"
              ></DateSelect>
            </div>
            <div>
              <h4 class="col-md-1">結束時間：</h4>
              <DateSelect
                :isDisabled="suspendDialog.eternalCheck"
                :isSuspension="true"
                ref="endTime"
              ></DateSelect>
            </div>
          </el-col>
          <el-col :span="20" style="margin: 1rem">
            <el-input
              v-model="suspendDialog.note"
              placeholder="請輸入停權原因"
            />
          </el-col>
        </el-row>
        <el-col :span="24" style="margin: 1rem">
          <el-checkbox v-model="suspendDialog.eternalCheck">
            永久停權
          </el-checkbox>
        </el-col>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeSuspendDialog">取消關閉</el-button>
          <el-button type="primary" @click="confirmSuspendDialog">
            確定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  reqDownloadDriver,
  reqList,
  reqSuspensionMsgToDriver,
} from '@/api/driverList'
import dayjs from 'dayjs'
import { mapActions, mapState } from 'vuex'
import { cookies } from '@/utils/cookies'
import { MessageBox, Notification, Loading } from 'element-ui'
import { authOptions } from '@/constants/select'
import {
  InTeamTable,
  SealTable,
  DriverLicenseModal,
  ServiceListModalBug,
} from './components'
import DateSelect from '@/components/tool/DateSelect'
import { getAdminAuthorization } from '@/assets/js/tool/adminAuth'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import Driver from '@/assets/js/libs/Driver'

const driver = new Driver()
export default {
  name: 'DriverList',
  components: {
    ServiceListModalBug,
    DriverLicenseModal,
    InTeamTable,
    SealTable,
    DateSelect,
  },
  data() {
    return {
      /* 司機資料篩選條件 */
      kw: '',
      serviceItem: [],
      auth: '',
      /* 司機資料 */
      list: [],
      filter_list: [],
      activeTab: 'general',
      driverAuth: null,
      sortBy: 'call_number',
      orderBy: true,
      filter: '',
      task: 'general',
      paging: {
        currentPage: 1,
        npp: 10,
        totalPages: 1,
        totalEntries: null,
      },
      /* 停權dialog */
      suspendDialog: {
        visible: false,
        /* authDate: [null, null], */
        eternalCheck: false,
        driverId: null,
        authorize: null,
        note: null,
        callNumber: null,
        name: null,
      },
    }
  },
  methods: {
    ...mapActions('hail', {
      vx_fetchServiceList: 'fetchServiceList',
    }),
    /* initSuspendDialog() {
      this.suspendDialog.authDate = null
      this.suspendDialog.note = null
      this.suspendDialog.eternalCheck = false
    }, */
    async changeDriverAuth(val, id, callNumber, name) {
      /* 授權 */
      if (val === 0) {
        const payload = {
          call_number: callNumber,
          authorize: val,
        }
        const result = await driver.updateSuspension(id, payload)
        if (result.success) {
          Notification({
            title: '授權成功',
            type: 'success',
          })
          BehaviorRecorder.record(
            '點擊',
            '司機資料',
            `恢復正常權限-${callNumber}`,
          )
          this.fetchList(this.paging.currentPage)
        } else {
          Notification({
            title: '授權失敗，請稍後再試',
            type: 'error',
          })
        }
      }
      /* 停權 */
      if (val === 1) {
        /* this.initSuspendDialog() */
        this.suspendDialog.driverId = id
        this.suspendDialog.authorize = val
        this.suspendDialog.callNumber = callNumber
        this.suspendDialog.name = name
        /* 打開dialog */
        this.suspendDialog.visible = true
      }
    },
    async confirmSuspendDialog() {
      try {
        const { eternalCheck, driverId, authorize, note, callNumber } =
          this.suspendDialog
        /* 判斷有無輸入時間與停權原因 */
        const start = this.$refs.startTime.getDate()
        const end = this.$refs.endTime.getDate()
        if (!eternalCheck && !start && !end) {
          Notification({
            message: '請輸入停權時間',
            type: 'warning',
          })
          return
        }
        if (!eternalCheck && dayjs(start).isAfter(end)) {
          Notification({
            message: '結束時間須大於起始時間',
            type: 'warning',
          })
          return
        }
        if (!note) {
          Notification({
            message: '請輸入停權原因',
            type: 'warning',
          })
          return
        }
        /* 司機的停權資訊 */
        const payload = {
          call_number: callNumber,
          authorize: authorize,
          suspension_reason: note,
          startSuspensionTime: eternalCheck ? null : start,
          suspensionUntil: eternalCheck ? null : end,
        }

        /* console.log("payload", payload); */
        const result = await driver.updateSuspension(driverId, payload)
        if (result.success) {
          Notification({
            message: '停權成功',
            type: 'success',
          })
          BehaviorRecorder.record(
            '點擊',
            '司機資料',
            `設定司機停權-${callNumber} ,停權時間: ${
              eternalCheck ? '永久停權' : start + '~' + end
            }, 停權原因:${note ? note : '無'}`,
          )
          this.suspendDialog.visible = false
          this.fetchList(this.paging.currentPage)
          /* 推送停權訊息給司機 */
          MessageBox.confirm(
            '由於司機被停權，是否要強制司機回到離線狀態？',
            '提示',
            {
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              type: 'warning',
            },
          ).then(() => {
            reqSuspensionMsgToDriver({
              title: '停權訊息',
              driverId: driverId,
              content: {
                startTime: payload.startSuspensionTime,
                endTime: payload.suspensionUntil,
                message: note,
              },
            })
          })
        } else {
          Notification({
            title: '停權失敗',
            message: '停權失敗，請稍後再試',
            type: 'error',
          })
        }
      } catch (e) {
        console.error(e)
        Notification({
          title: '停權失敗',
          message: '停權失敗，請稍後再試',
          type: 'error',
        })
      }
    },
    /* 右上角叉叉btn */
    beforeCloseSuspendDialog(done) {
      this.closeSuspendDialog()
      /* 需要加入element-ui中done這個callback function才能點擊叉關閉dialog */
      done()
    },
    /* 右下角取消關閉btn */
    closeSuspendDialog() {
      this.suspendDialog.visible = false
      this.fetchList(this.paging.currentPage)
    },
    async downloadDriver() {
      BehaviorRecorder.record('點擊', '司機資料', '下載司機資料')
      try {
        await reqDownloadDriver()
        const routeUrl = this.$router.resolve({
          path: '/serviceMain/WorkingStatus',
        })
        window.open(routeUrl.href, '_blank')
      } catch (e) {
        Notification({
          title: '錯誤',
          message: '下載司機資料發生錯誤，請稍後再試',
          type: 'error',
        })
        console.error(e)
      }
    },
    filterList() {
      const loading = Loading.service()
      // 用kw作為列表資料的排序條件
      const filterListBySearch = this.list
        .filter((driver) => {
          let haskey = false
          for (const key in driver) {
            if (key == 'id') continue
            if (driver[key] === null) continue
            driver[key].toString()
            if (driver[key].toString().includes(this.kw)) {
              haskey = true
            }
          }
          return haskey
        })
        .sort((a, b) =>
          this.orderBy
            ? a[this.sortBy] - b[this.sortBy]
            : b[this.sortBy] - a[this.sortBy],
        )
      // 頁籤
      this.paging.totalEntries = filterListBySearch.length
      this.paging.totalPages = Math.ceil(
        filterListBySearch.length / this.paging.npp,
      )
      // 擷取當頁呈現的列表資料
      const startIdx = (this.paging.currentPage - 1) * this.paging.npp
      let endIdx = this.paging.currentPage * this.paging.npp
      if (endIdx > filterListBySearch.length) {
        endIdx = filterListBySearch.length
      }
      this.filter_list = filterListBySearch.slice(startIdx, endIdx)
      /* console.log("filter_list", this.filter_list); */
      loading.close()
    },
    async fetchList(currentPage = 1) {
      /* console.log("currentPage", currentPage) */
      const loading = Loading.service()
      try {
        const { driverList } = await reqList(this.task, this.filter, this.auth)
        this.list = driverList
        // 頁籤
        this.paging.currentPage = currentPage
        // 排序與篩選當頁所呈現的資料
        this.filterList()
      } catch (e) {
        console.error(e)
      } finally {
        loading.close()
      }
    },
    onChangeServiceItem(val) {
      this.filter = val.join(',')
      this.fetchList()
    },
    onChangeAuth() {
      this.fetchList()
    },
    onDetailBtnClick(id) {
      cookies.set('driver', id)
      location.href = 'driver_edit.html'
    },
    onTab(tab) {
      this.task = tab.name
      this.fetchList()
    },
    onSelect(npp) {
      this.paging.npp = npp
      this.paging.currentPage = 1
      this.paging.totalPages = Math.ceil(this.paging.totalEntries / npp)
      this.filterList()
    },
    onSearch() {
      this.paging.currentPage = 1
      this.filterList()
    },
    onTitle(sortBy) {
      if (sortBy == this.sortBy) this.orderBy = !this.orderBy
      this.sortBy = sortBy
      this.filterList()
    },
    onPageChange(page) {
      this.paging.currentPage = page
      this.filterList()
    },
    openDriverLicenseModal() {
      BehaviorRecorder.record('點擊', '司機資料', '查看司機審查名單')
      this.$refs.driverLicenseModal.showModal()
    },
    openServiceModal() {
      this.$refs.serviceListModal.showModal()
    },
  },
  computed: {
    ...mapState('hail', {
      vx_serviceList: 'serviceList',
    }),
    permissionAddDriver() {
      return getAdminAuthorization('addDriver') === 2
    },
    permissionEditDriver() {
      return (
        getAdminAuthorization('editDriver') === 1 ||
        getAdminAuthorization('editDriver') === 2
      )
    },
    permissionDriverService() {
      return (
        getAdminAuthorization('defaultDriverService') === 1 ||
        getAdminAuthorization('defaultDriverService') === 2
      )
    },
    permissionEditDriverService() {
      return getAdminAuthorization('defaultDriverService') === 2
    },
    dialogTitle() {
      return `${this.suspendDialog.callNumber}-${this.suspendDialog.name} 設定停權時間`
    },
  },
  mounted() {
    this.fetchList()
    this.vx_fetchServiceList()
  },
  created() {
    this.AUTH_OPTIONS = authOptions
  },
}
</script>

<style scoped>
h4 {
  min-width: 140px;
}

.el-col {
  margin-bottom: 8px;
}

input.inputstyle {
  min-width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/DriverList.vue